module.exports = __webpack_public_path__ + "img/mine.6c118a71.png";